import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import { Compte } from '../../model/compte';
import { plainToClass } from 'class-transformer';
// import {SharedMethods} from "../../../util/sharedMethods";
// import {NetworkService} from "../../../util/NetworkService";
import { SharedMethods } from '../../../../util/sharedMethods-service';



@Injectable()
export class CompteService {

  comptes: Compte[];

  iSconnecting: boolean = false;

  // caisse: Compte;

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              // public sharedMethods: SharedMethods
              public sharedMethods: SharedMethods,
              ) { }

  getComptes() {
    this.iSconnecting = true;
    return new Promise<Compte[]>(resolve => {
      this.http.get(this.apiEndpoints.URL_GET_COMPTES,
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe((data: Compte[]) => {
            const comptes = plainToClass(Compte, data);
            this.comptes = comptes;
            resolve(comptes);
            this.iSconnecting = false;
          },
          err => {
            // console.log(err);
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            this.iSconnecting = false;
          });
    });
  }


  getCompte(id: number)  {

    if (this.comptes !== undefined) {

          return new Promise<Compte>( resolve => {

            for ( let i = 0; i < this.comptes.length; i++) {

              if (this.comptes[i].id === id) {
                resolve( this.comptes[i]);
              }

            }

          });

    } else {

      return new Promise<Compte>( resolve => {
          this.getComptes().then( comptes => {
            for ( let i = 0; i < this.comptes.length; i++) {

                if (this.comptes[i].id === id) {
                  resolve( this.comptes[i]);
                }

            }

          });
      });

      /* this.iSconnecting = true;
      return new Promise<Compte>(resolve => {
        this.http.get(this.apiEndpoints.URL_GET_COMPTE(id),
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Compte) => {
              const compte = plainToClass(Compte, data);
              resolve(compte);
              this.iSconnecting = false;
            },
            err => {
              // console.log(err);
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              this.iSconnecting = false;
            });
      }); */
    }


  }


  /* getCompteCaisse() {

    return new Promise<Compte>(resolve => {

      this.getCompteByNum(57).then( compte => {

        this.caisse = compte;
        resolve(compte);

      });

    });


  }
 */


  saveCompte(compte: Compte) {

    this.iSconnecting = true;
    let idcompte = null;

    if (compte.parent !== null && compte.parent !== undefined)
    idcompte = compte.parent.id;

    const compt = {
      designation: compte.designation,
      parent: idcompte,
      // typeCompte: compte.type_compte,
    };


    if (compte.id !== 0) {

      this.iSconnecting = true;

      return new Promise<Compte>(resolve => {
        this.http.put(this.apiEndpoints.GET_URL_PUT_COMPTES(compte.id), compt,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Compte) => {

              this.getComptes().then( comptes => {
                resolve(data);
                this.iSconnecting = false;
              });

            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });

    }else {

      return new Promise<Compte>(resolve => {
        this.http.post(this.apiEndpoints.GET_URL_POST_COMPTES, compt,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Compte) => {

              this.getComptes().then( comptes => {
                resolve(data);
                this.iSconnecting = false;
              });

            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });

    }



  }

  deleteCompte(id: number) {
    this.iSconnecting = true;
    return new Promise(resolve => {
      this.http.delete(this.apiEndpoints.GET_URL_DELETE_COMPTES(id),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe(data => {

            this.getComptes().then( comptes => {
              resolve(data);
              this.iSconnecting = false;
            });

          },
          err => {
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            // alert(JSON.stringify(err));
            this.iSconnecting = false;
          });
    });


  }


}
